import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import Alert from '../../apps/common/Alert';
import urlManager from '../../services/urlManager';

export const SecurityAlert: React.FC = () => {
  const { t } = useTranslation();
  if (!urlManager.backUrlSecure) {
    return <Alert>{t('SecurityAlert')}</Alert>;
  }
  return null;
};

export default SecurityAlert;
